<template>
  <div class="details">
    <div class="title">{{ title }}</div>
    <div v-show="describe" class="line"></div>
    <div class="describe">
      <slot name="describe"></slot>
    </div>
    <div v-show="imgSrc" :class="scale ? 'details-img' : ''"><img :src="imgSrc" /></div>
    <div v-show="htmlStr" class="htmlStr" v-html="htmlStr"></div>
  </div>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
      default: '',
    },
    describe: {
      type: Boolean,
      default: false,
    },
    imgSrc: {
      type: String,
      default: '',
    },
    scale: {
      type: Boolean,
      default: false,
    },
    htmlStr: {
      type: String,
      default: '',
    },
  },
}
</script>
<style lang="stylus">
.details
  margin 48px 0 107px 0
  min-height 800px
  .title
    font-size 36px
    color #000
    margin-bottom 40px
  .line
    width 1280px
    height 1px
    border-bottom 1px rgba(0, 0, 0, 0.2) solid
    margin 0 auto
    margin-bottom 50px
  .describe
    line-height 30px
    font-size 18px
    max-width 1280px
    margin 0 auto
    margin-bottom 40px
    text-align center
  .htmlStr
    margin-top 50px
    max-width 1280px
    margin 0 auto
    p
      line-height 2em
      font-size 16px
      text-indent 0
      img
        max-width 1280px
        height auto
  .details-img
    max-width 1280px
    margin 0 auto
    overflow hidden
</style>
